/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Normalizes paginated appointment list API responses for ViewAppointments state.
 * @module logic/appointments/appointmentsPageResponse
 */

/**
 * @param {Object|null|undefined} pageData
 * @returns {{ items: Array<Object>, total: number, page: number }}
 */
export const normalizeAppointmentsPageResponse = (pageData) => ({
  items: pageData?.items || [],
  total: pageData?.total || 0,
  page: pageData?.page || 1,
});
